import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const GoldPriceChart = ({ data, onRangeChange }) => {
  const [timeRange, setTimeRange] = useState(100); // Default to 100% of data
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(data.length - 1);

  // Handle time range slider change
  const handleTimeRangeChange = (e) => {
    const newRange = parseInt(e.target.value);
    setTimeRange(newRange);
    
    // Calculate new indices based on slider value
    const totalDays = data.length;
    const daysToShow = Math.max(7, Math.floor(totalDays * newRange / 100));
    const newStartIndex = Math.max(0, totalDays - daysToShow);
    
    setStartIndex(newStartIndex);
    setEndIndex(totalDays - 1);
    
    // Notify parent component about the range change
    if (onRangeChange) {
      onRangeChange(newStartIndex, totalDays - 1);
    }
  };

  // Filter data based on selected time range
  const filteredData = data.slice(startIndex, endIndex + 1);

  // Custom tooltip to format the price in INR for 8g gold
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip" style={{ 
          backgroundColor: 'white', 
          padding: '10px', 
          border: '1px solid #ccc',
          borderRadius: '5px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <p className="label" style={{ margin: '0 0 5px 0' }}>{`Date: ${label}`}</p>
          <p className="price" style={{ margin: '0', color: '#341539' }}>
            {`Price: ₹${payload[0].value.toLocaleString('en-IN')}`}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-container">
      <h2>
        Gold Price History 
        <span className="currency-badge">INR</span>
        <span className="weight-badge">8g</span>
      </h2>
      
      <div className="slider-container">
        <input
          type="range"
          min="10"
          max="100"
          value={timeRange}
          onChange={handleTimeRangeChange}
          className="time-range-slider"
        />
        <div className="time-range-labels">
          <span>Last {Math.round(timeRange/10)} days</span>
          <span>All data</span>
        </div>
      </div>
      
      <ResponsiveContainer width="100%" height={400}>
        <LineChart
          data={filteredData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey="date" 
            tick={{ fill: '#333' }}
            tickLine={{ stroke: '#333' }}
          />
          <YAxis 
            tick={{ fill: '#333' }}
            tickLine={{ stroke: '#333' }}
            domain={[70000, 75000]}
            tickFormatter={(value) => `₹${(value / 1000).toFixed(0)}K`}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Line
            type="monotone"
            dataKey="price"
            stroke="#341539"
            activeDot={{ r: 8, fill: '#4e2255', stroke: '#240e29' }}
            strokeWidth={2}
            dot={{ r: 3, fill: '#341539', stroke: '#240e29' }}
            name="Gold Price (8g)"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GoldPriceChart;